/* eslint-disable */
import session from './session';

export default {
    getAddressList(filter) {
        return session.get(`address/${filter}`);
    },
    getAddress(id) {
        return session.get(`address/${id}/`);
    },
    deleteAddress(id) {
        return session.delete(`address/${id}/`);
    },
    createAddress(data) {
        return session.post(`address/`, data);
    },
    updateAddress(id, data) {
        return session.patch(`address/${id}/`, data );
    },
};